import React from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import { seniorManagementData } from "../data/seniorManagementData";
import "../css/SeniorManagementDetailPage.css";

const SeniorManagementDetailPage = () => {
  const { slug } = useParams();
  const member = seniorManagementData[slug];

  if (!member) {
    return (
      <>
        <Header />
        <div className="senior-management-detail-error">
          <p>Senior Management member not found.</p>
          <Link to="/senior-managment-team">
            Back to Senior Management Team
          </Link>
        </div>
        <Footer />
        <BackToTop />
      </>
    );
  }

  const { name, title, image, descriptionLong } = member;

  return (
    <>
      <Header />

      <div className="senior-management-detail-wrapper">
        <div className="center-container">
          {/* Breadcrumb */}
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt;{" "}
            <Link to="/senior-managment-team">Senior Management Team</Link> &gt;{" "}
            <span>{name}</span>
          </div>

          {/* Dark name banner */}
          <div className="senior-name-banner">
            <h1>{name}</h1>
            <p
              className="senior-management-banner-title"
            >
              {title}
            </p>
          </div>

          <div className="senior-management-detail-container">
            <div className="senior-management-detail-image">
              <img src={image} alt={name} />
            </div>
            <div
              className="senior-management-detail-content"
            >
              <h2>{name}</h2>
              <p className="senior-management-detail-title">{title}</p>
              <hr className="senior-management-detail-hr" />
              <div
                className="senior-management-detail-description"
                dangerouslySetInnerHTML={{ __html: descriptionLong }}
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default SeniorManagementDetailPage;
